export const TYPES = {
  BOOLEAN: 'boolean',
  ARRAY: 'array',
  STRING: 'string',
};

export const FLAGS_CONFIG = {
  ENABLE_HOTEL_LANGUAGE_SUPPORT: {
    type: TYPES.ARRAY,
    separator: ',',
    default: 'en-gb',
  },
  ENABLE_HOTEL_WEB_IOS: { type: TYPES.BOOLEAN, default: 'FALSE' },
  ENABLE_HOTEL_WEB_ANDROID: { type: TYPES.BOOLEAN, default: 'FALSE' },
  HOTEL_SSO_AUTO_POPULATE: { type: TYPES.BOOLEAN, default: 'FALSE' },
  HOTEL_ENABLE_SEARCH_HEADER: { type: TYPES.BOOLEAN, default: 'FALSE' },
  HOTEL_IMAGE_GALLERY: { type: TYPES.BOOLEAN, default: 'FALSE' }, // v1
  HOTEL_IMAGE_GALLERY_WEB: { type: TYPES.BOOLEAN, default: 'FALSE' },
  HOTEL_IMAGE_GALLERY_NATIVE: { type: TYPES.BOOLEAN, default: 'FALSE' },
  ENABLE_HOTEL_WEB_LANGUAGE_SELECTION: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_HOTEL_WEB_CURRENCY_SELECTION: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_MOBILE_CURRENCY_SELECTION: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_LIST_BATCH_SIZE: {
    type: TYPES.STRING,
    default: '150',
  },
  HOTEL_ENABLE_RE_SEARCH_V2_MOBILE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_RE_SEARCH_V2_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SNAP_SEARCH_MULTIPLE_ROOMS: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_TRIPADVISOR_WRAPPER_SERVICE_SNAP_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_TRIPADVISOR_WRAPPER_SERVICE_SNAP_MOBILE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_HOTEL_SPECIAL_REQUEST: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_GUEST_DETAILS_PRICE_BREAKUP_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_GUEST_DETAILS_PRICE_BREAKUP_NATIVE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_NPS_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_NPS_MOBILE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_FOCUS_HOTEL_HIGHLIGHT: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_PAY_AT_HOTEL_TESTING: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_GUEST_DETAILS_PULL: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_ROOM_RECOMMENDED: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_NEW_HOTEL_SEARCH_WIDGET: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_TEST_PRICE_CHANGED: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_POI: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENBALE_CHILD_AGE_INPUT: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_DISCOUNT_POPUP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_AMENITIES_FILTER: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_NEW_HOTEL_CARD: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_SINGLE_IMAGE_HOTEL_CARD: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_BIGPOINTS_TOGGLE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_HOTEL_CLASS_FILTER_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_SORT_BY_V2_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_HOTEL_CLASS_FILTER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_SHOW_MAP_ENTRY_POINT: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_MANDATE_LOGIN_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_PRICE_FILTER: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_PRICE_FILTER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_NEIGHBOURHOOD_FILTER: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_HOTEL_LISTING_FEEDBACK: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_ROOM_SELECT_FEEDBACK: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_GUEST_DETAILS_FEEDBACK: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_MAPS_FEEDBACK: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },

  HOTEL_ENABLE_PAYMENT_CANCELLATION_POLICY_FILTER: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },

  HOTEL_ENABLE_GUEST_REVIEW_OVERVIEW: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },

  HOTEL_ENABLE_GUEST_REVIEW_OVERVIEW_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },

  HOTEL_ENABLE_GUEST_REVIEW_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },

  HOTEL_ENABLE_GUEST_REVIEW_MOBILE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_NEW_SORT_BY_MOBILE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SORT_FILTER_NEW_UI: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_REARRANGE_FILTER_SECTION_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_PAYMENT_CANCELLATION_POLICY_FILTER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_DISCOUNT_SUPERFEST: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_NEW_ROOM_CARD_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_COMBO_SAVING_TAG_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_COMBO_SAVING_BUTTONCLICK_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_COMBO_SAVING_TAG_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_NEW_SELECT_ROOM_BUTTON_HOTEL_CARD: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_NEW_ROOM_CARD_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_NEW_ROOM_CARD_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_SEO_UPDATE_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_CUSTOMIZED_RATE_NAME_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_CUSTOMIZED_RATE_NAME_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_VOUCHER_BANNER_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_ROOM_FILTERS_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_ROOM_FILTERS_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_PROPERTY_TYPES_FILTER: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PROPERTY_FILTER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PROPERTY_FILTER_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_SNAP_ENABLE_NEW_DEAL_CTA: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_PROPERTY_TYPES_FILTER_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_SA_ENABLE_NEW_DEAL_CTA: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_DEAL_OF_THE_DAY_TIME: {
    type: TYPES.STRING,
    default: '01:00:00',
  },
  HOTEL_LIST_GOOGLE_ADS_SIZE: {
    type: TYPES.STRING,
    default: '970,90',
  },
  ENABLE_GOOGLEADS_LISTING_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_INDEX_OF_ADS_LSTINGPAGE: {
    type: TYPES.STRING,
    default: '4',
  },
  HOTEL_ENABLE_DEAL_OF_THE_DAY: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_PROMOTION_FILTER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_DEAL_OF_THE_DAY_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_PROMOTION_FILTER_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_HOTEL_NOT_AVAILABLE_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_HOTEL_NOT_AVAILABLE_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_ROOM_DETAILS_MENU_TAB_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_MY_TOURISM_TAX_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_MY_TOURISM_TAX_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SHOW_RECOMMENDATION_HOTEL: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  SHOW_COMBO_SAVINGS_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  SHOW_PROMOTION_FILTER_CHECKBOX_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_ROOM_PAGE_REDESIGNED_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ROOM_DETAILS_DATE_SELECTION_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_NEW_FILTER_TOP_VIEW_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_FILTER_PLACEMENT_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SCROLLUP_BUTTON: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SNAP_CANCELLATION_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SNAP_CANCELLATION_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_FILTER_REARRANGEMENT_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_EXPIRED_POPUP_MESSAGE: {
    type: TYPES.BOOLEAN,
    default: 'TRUE',
  },
  ENABLE_EXPIRED_POPUP_MESSAGE_WEB: {
    type: TYPES.BOOLEAN,
    default: 'TRUE',
  },
  ENABLE_SELECT_ROOM_LABEL_HOTEL_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_DROPOUT_PROMO_CODE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_DROPOUT_PROMO_CODE: {
    type: TYPES.STRING,
    default: 'HOTELGETRM30|RM30',
  },
  ENABLE_BIGPAY_CARD_PROMO_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_ROOM_CARD_COLUMNISED_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_FAVOURITES_HOTEL_MOBILE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_HOTEL_GUEST_RATING_DISELECT_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_HOTEL_GUEST_RATING_DISELECT_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_DISTANCE_FROM_CITY_CENTER_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_DISTANCE_FROM_CITY_CENTER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_TYPESENSE_AB_TESTING: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_SOLD_OUT: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PAYMENT_CARD_MESSAGE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SWIPABLE_CAROUSEL: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_GOOGLE_ADS_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_BANNER_IMAGE_APP_AB_TESTING: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_TRIPADVISOR_RATING: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_SHOW_MAP_ENTRY_POINT_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_ENABLE_GOOGLEADS_LISTING_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_GOOGLEADS_LISTING_INDEX_APP: {
    type: TYPES.STRING,
    default: '4',
  },
  HOTEL_COLLECTIONS_EXPERIMENT_ENABLED: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SNAP_COLLECTIONS_EXPERIMENT: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_GOOGLE_ADS_BOOKING_DETAILS_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_PROMO_CODE_ENABLED_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_PROMO_BANNER_ENABLED_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  DESTINATION_FOR_AB_TESTING: {
    type: TYPES.STRING,
    default: '0',
  },
  HOTEL_PROMO_CODE_ENABLED_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_FOMO_MESSAGES_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_FAST_FILLING_FOMO: {
    type: TYPES.STRING,
    default: '0',
  },
  HOTEL_BOOKINGS_DONE_FOMO: {
    type: TYPES.STRING,
    default: '0',
  },
  HOTEL_LAST_ROOM_FOMO: {
    type: TYPES.STRING,
    default: '0',
  },
  HOTEL_LAST_ROOM_COUNT_FOMO: {
    type: TYPES.STRING,
    default: '0',
  },
  HOTEL_PRICE_DROP_FOMO: {
    type: TYPES.STRING,
    default: '0',
  },
  HOTEL_ENABLE_SOLD_OUT_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_PROMO_BANNER_ENABLED_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_FOMO_MESSAGES_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_BOGO_PROMO_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_GOOGLEMAPS_COLORED_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_GOOGLEMAPS_COLORED_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_BOGO_PROMO_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_BOGO_DISCOUNT_ID: {
    type: TYPES.STRING,
    default: '0',
  },
  HOTEL_PAYNOW_FILTER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_DROPOUT_PROMO_COUNTRY_SPECIFIC: {
    type: TYPES.STRING,
    default: null,
  },
  HOTEL_LISTING_PROMO_CODE_IDS: {
    type: TYPES.STRING,
    default: null,
  },
  HOTEL_PAYNOW_FILTER_LISTING_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_PAYNOW_FILTER_LISTING_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_PAYNOW_PROMO_CODE_IDS: {
    type: TYPES.STRING,
    default: '',
  },
  HOTEL_PAYNOW_TAG_LISTING_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_PAYNOW_TAG_LISTING_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_PAYNOW_PROMO_CODE_IDS_WEB: {
    type: TYPES.STRING,
    default: '',
  },
  HOTEL_DEFAULT_PAY_NOW_SELECTION_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SORT_FILTER_MAP_VIEW_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_MAP_VIEW_SEARCH_HEADER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_MULTIPLE_CURRENCY_MAP_HEADER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_NEW_LISTING_HOTEL_CARD: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_NEW_MAP_HOTEL_CARD: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_REBRANDING_HOTEL_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_REBRANDING_HOTEL_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_REBRANDING_SNAP_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_SMARTFILL_API_AB_TESTING: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_NEW_SNAP_MAP_HOTEL_CARD: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  HOTEL_PAYLATER_TAG_LISTING_APP: {
    type: TYPES.BOOLEAN,
    default: 'TRUE',
  },
  HOTEL_PAYLATER_TAG_LISTING_WEB: {
    type: TYPES.BOOLEAN,
    default: 'TRUE',
  },
  ENABLE_USER_SUBSCRIPTION_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_USER_SUBSCRIPTION_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PAX_AGE_UPDATE_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PAX_AGE_UPDATE_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_CROSS_SELL_BANNER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_CROSS_SELL_BANNER_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  FLYER_DISCOUNT_BANNER_IMG_APP: {
    type: TYPES.STRING,
    default: '',
  },
  FLYER_DISCOUNT_BANNER_IMG_WEB: {
    type: TYPES.STRING,
    default: '',
  },
  CROSS_SELL_DISCOUNT_PERCENTAGE: {
    type: TYPES.STRING,
    default: '',
  },
  CROSS_SELL_PROMO_CODE: {
    type: TYPES.STRING,
    default: '',
  },
  CROSS_SELL_PERCENT_VALUE: {
    type: TYPES.STRING,
    default: '',
  },
  ENABLE_HOTEL_FOMO_MESSAGES_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_HOTEL_BOOKINGS_DONE_FOMO: {
    type: TYPES.STRING,
    default: '',
  },
  ENABLE_HOTEL_LAST_ROOM_FOMO: {
    type: TYPES.STRING,
    default: '',
  },
  ENABLE_HOTEL_LAST_ROOM_COUNT_FOMO: {
    type: TYPES.STRING,
    default: '',
  },
  ENABLE_HOTEL_FAST_FILLING_FOMO: {
    type: TYPES.STRING,
    default: '',
  },
  ENABLE_SNAP_HOTEL_DISCOUNT_TYPE: {
    type: TYPES.STRING,
    default: '',
  },
  EXCLUSIVE_DEAL_TYPE_ID: {
    type: TYPES.STRING,
    default: '',
  },
  BOGO_DISCOUNT_BANNER_IMG_APP: {
    type: TYPES.STRING,
    default: '',
  },
  BOGO_DISCOUNT_BANNER_IMG_WEB: {
    type: TYPES.STRING,
    default: '',
  },
  BOGO_DISCOUNT_PERCENTAGE: {
    type: TYPES.STRING,
    default: '',
  },
  BOGO_PROMO_CODE: {
    type: TYPES.STRING,
    default: '',
  },
  BOGO_PERCENT_VALUE: {
    type: TYPES.STRING,
    default: '',
  },
  BOGO_BANNER_LABEL_TEXT: {
    type: TYPES.STRING,
    default: '',
  },
  RM9_DISCOUNT_BANNER_IMG_APP: {
    type: TYPES.STRING,
    default: '',
  },
  RM9_DISCOUNT_BANNER_IMG_WEB: {
    type: TYPES.STRING,
    default: '',
  },
  RM9_DISCOUNT_PERCENTAGE: {
    type: TYPES.STRING,
    default: '',
  },
  RM9_PROMO_CODE: {
    type: TYPES.STRING,
    default: '',
  },
  RM9_PERCENT_VALUE: {
    type: TYPES.STRING,
    default: '',
  },
  RM9_BANNER_LABEL_TEXT: {
    type: TYPES.STRING,
    default: '',
  },
  HOTEL_ENABLE_FLYER_DISCOUNT_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_BOGO_TOGGLE_BANNER_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_BOGO_TOGGLE_BANNER_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  PROMO_DISCOUNT_LOCATIONS: {
    type: TYPES.STRING,
    default: '0',
  },
  ENABLE_SNAP_CHECKOUT_V4: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_HOTEL_CARD_RM9_BUTTON: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_HOTEL_CARD_RM9_BUTTON_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_IDR_VND_SAVINGLABEL_SORTED: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_ROUND_SAVINGLABEL_CURRENCY: {
    type: TYPES.STRING,
    default: '',
  },
  ENABLE_EINVOICE_CONFIRMATION_PAGE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_EINVOICE_CONFIRMATION_PAGE_MOBILE: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_ERROR_REVAMP_SNAP: {
    type: TYPES.STRING,
    default: 'FALSE',
  },
  ENABLE_PRICEBUCKETS_FROM_CONFIG_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PRICEBUCKETS_FROM_CONFIG_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_AUD: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_MYR: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_CNY: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_EUR: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_GBP: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_HKD: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_JPY: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_NZD: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_PHP: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_SGD: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_THB: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_USD: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_BDT: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_BND: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_INR: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_IDR: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_KRW: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_MOP: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_TWD: {
    type: TYPES.STRING,
    default: '',
  },
  PER_PERSION_PRICE_FILTER_BUCKETS_FOR_VND: {
    type: TYPES.STRING,
    default: '',
  },
  ENABLE_LEMON_ADT_DUTYTRAVEL: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_ORACLE_ID_FIELD: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PRE_CHECKOUT_CALL_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PRE_CHECKOUT_CALL_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PRE_CHECKOUT_CALL_GUEST_DETAILS_PAGE_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PRE_CHECKOUT_CALL_GUEST_DETAILS_PAGE_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_PRICE_MESSAGE_BOOKING_DETAILS: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_ROOM_DEDUPE_EXPERIMENT: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_NEW_IP_URL: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_NEW_IP_URL_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SEO_DATA: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  SHOW_HOTEL_CONTENT_HOTEL_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  SHOW_HOTEL_CONTENT_SNAP_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  SHOW_HOTEL_CONTENT_HOTEL_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_INSTALLMENT_LISTING_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  SHOW_HOTEL_CONTENT_SNAP_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_NEW_FLIGHT_CARD: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_INSTALLMENT_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_BLOCKED_RATES_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_BLOCKED_RATES_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_REMOVE_BACK_NAVIGATION_APP: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_REMOVE_BACK_NAVIGATION_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_SENDING_MFT_PARAMETER: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  ENABLE_EXTRA_ROOM_AMENITIES: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  SUPPORTED_CURRENCIES: {
    type: TYPES.ARRAY,
    separator: ',',
    default: 'MYR',
  },
  ENABLE_EXTRA_ROOM_AMENITIES_WEB: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
  SEND_REFRESH_TOKEN_IN_BFFAPIS: {
    type: TYPES.BOOLEAN,
    default: 'FALSE',
  },
};
export const FLAGS = Object.keys(FLAGS_CONFIG);
